import { WORKOUT_EXERCISE_KEY } from '../../../model'
import { SET_DATA_KEY } from '../../../model/constants'
import { getRepsFromDurationSetDataUtil } from '../../../model/utils'
import { isWarmUpOrStretchingWorkoutSectionUtil } from '../../../../workout-section/model/utils/is-warmup-or-stretching'
import { EXERCISE_ID, EXERCISE_KEY, EXERCISE_TYPE, getTypeExerciseUtil } from '../../../../exercise'
import createExerciseLogSummaryAction from '../../../../exercise-log-summaries/actions/create'
import getBarbellBenchPressExerciseLogSummarySelect
  from '../../../../exercise-log-summaries/selectors/get-barbell-bench-press'
import getBarbellDeadliftExerciseLogSummarySelect
  from '../../../../exercise-log-summaries/selectors/get-barbell-deadlift'
import getBarbellSquatExerciseLogSummarySelect from '../../../../exercise-log-summaries/selectors/get-barbell-squat'
import getByExerciseIdExerciseLogSummarySelector from '../../../../exercise-log-summaries/selectors/get-by-exercise-id'
import getByIdExerciseSelector from '../../../../exercise/redux/selectors/get-by-id'
import getIdsByMuscleExerciseSelector from '../../../../exercise/redux/selectors/get-ids-by-muscle'
import { MINOR_MUSCLES, MUSCLE, MUSCLE_COMBINATIONS } from '../../../../muscles'
import { getWeightUnitProfileSelect } from '../../../../profile/redux/selectors/get-weight-unit'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { getEquipmentWeightUtil, getWeightEquipmentValueUtil } from '../../../../weight/utils/get-equipment'
import { getEquipmentTypeWeightUtil } from '../../../../weight/utils/get-equipment-type'
import { isBarEquipmentWeightUtil } from '../../../../weight/utils/is-bar'
import { isDumbbellOrKettlebellEquipmentWeightUtil } from '../../../../weight/utils/is-dumbbel-or-kettlebell'
import updateWorkoutExerciseAction from '../update'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import getCurrentWorkoutExerciseSelect from '../../selectors/get-current'
import getByIdWorkoutSectionSelector from '../../../../workout-section/redux/selectors/get-by-id'
import { isEqualUtil, logUtil } from 'packages/src'
import { getMusclesExerciseUtil } from '../../../../exercise/model/utils/get-muscles'
import {
  getEstimatedOneRepMaxExerciseLogSummaryUtil,
  getOneRepMaxExerciseLogSummaryUtil,
  getWeightFromRepsAndOneRepMaxExerciseLogSummaryUtil
} from '../../../../exercise-log-summary/model/utils'
import { EXERCISE_LOG_SUMMARY_KEY } from '../../../../exercise-log-summary/model/constants'

function getSuggestedFromExerciseLogSummarySelector (exercise) {
  return (state) => {
    const type = getTypeExerciseUtil(exercise)
    if (![
      EXERCISE_TYPE.STRENGTH,
      EXERCISE_TYPE.POWERLIFTING,
      EXERCISE_TYPE.OLYMPIC_WEIGHTLIFTING
    ].includes(type)) {
      return
    }

    // TODO move to exercises selector
    const muscle = getMusclesExerciseUtil(exercise)[0]
    let exerciseIdsForMuscle = (
      getIdsByMuscleExerciseSelector(muscle)(state)
    )
    if (!Array.isArray(exerciseIdsForMuscle)) {
      exerciseIdsForMuscle = []
    }

    let suggestedExercise
    let suggestedExerciseLogSummary
    exerciseIdsForMuscle.find(exerciseId => {
      const ex = getByIdExerciseSelector(exerciseId)(state)
      if (getTypeExerciseUtil(ex) !== type) {
        return false
      }
      suggestedExerciseLogSummary = getByExerciseIdExerciseLogSummarySelector(
        getIdReduxUtil(exercise))(
        state)
      if (suggestedExerciseLogSummary) {
        suggestedExercise = ex
      }
      return !!suggestedExerciseLogSummary
    })

    if (!suggestedExercise) {
      const muscle = getMusclesExerciseUtil(exercise)[0]
      if (MUSCLE_COMBINATIONS.CHEST_TRICEPS.includes(muscle) ||
        MUSCLE.SHOULDERS ===
        muscle) {
        suggestedExerciseLogSummary = (
          getBarbellBenchPressExerciseLogSummarySelect(state)
        )
        if (suggestedExerciseLogSummary) {
          suggestedExercise = getByIdExerciseSelector(EXERCISE_ID.BARBELL_BENCH_PRESS)(
            state)
        }
      } else if (MUSCLE_COMBINATIONS.BACK.includes(muscle)) {
        suggestedExerciseLogSummary = (
          getBarbellDeadliftExerciseLogSummarySelect(state)
        )
        if (suggestedExerciseLogSummary) {
          suggestedExercise = getByIdExerciseSelector(EXERCISE_ID.BARBELL_DEADLIFT)(
            state)
        }
      } else if (MUSCLE_COMBINATIONS.LEGS.includes(muscle)) {
        suggestedExerciseLogSummary = (
          getBarbellSquatExerciseLogSummarySelect(state)
        )
        if (suggestedExerciseLogSummary) {
          suggestedExercise = getByIdExerciseSelector(EXERCISE_ID.BARBELL_DEADLIFT)(
            state)
        }
      }
    }

    return {
      exercise: suggestedExercise,
      exerciseLogSummary: suggestedExerciseLogSummary
    }
  }
}

function getSuggestedOneRepMax (weight, exercise, suggestedExercise) {
  const equipmentType = getEquipmentTypeWeightUtil(exercise)
  if (!equipmentType) {
    return weight / 3
  }

  const suggestedEquipmentType = getEquipmentTypeWeightUtil(suggestedExercise)

  // TODO other equipment
  // logUtil('').debug(`${getValueReduxUtil(exercise, EXERCISE_KEY.NAME)}:
  // equipmentType ${equipmentType} `)
  // logUtil('').debug(`${suggestedExercise[EXERCISE_KEY.NAME]}:
  // suggestedEquipmentType ${suggestedEquipmentType} `)
  if (!isBarEquipmentWeightUtil(equipmentType) &&
    isBarEquipmentWeightUtil(suggestedEquipmentType)) {
    // If we go from barbell to dumbbell/kettlebell, decrease the weight
    // logUtil('').debug('If we go from barbell to dumbbell/kettlebell, decrease the
    // weight')
    weight /= 2.5
  } else if (!isDumbbellOrKettlebellEquipmentWeightUtil(equipmentType) &&
    isDumbbellOrKettlebellEquipmentWeightUtil(suggestedEquipmentType)) {
    // If we go from dumbbell/kettlebell to barbell, increase the weight
    // logUtil('').debug('If we go from dumbbell/kettlebell to barbell, increase the
    // weight')
    weight *= 2
  }

  const muscle = getMusclesExerciseUtil(exercise)[0]
  const suggestedMuscle = getMusclesExerciseUtil(suggestedExercise)[0]
  if (muscle === suggestedMuscle) {
    // If it is same muscle group, the weight should be adjusted correctly
    // see above
    // e.g. barbell bench press to dumbbell bench press
    // logUtil('').debug('If it is same muscle group, the weight should be adjusted
    // correctly')
    return weight / 1.5
  } else if (MINOR_MUSCLES.includes(muscle) &&
    !MINOR_MUSCLES.includes(suggestedMuscle)) {
    // If we go from a major to a minor muscle group, decrease the weight
    // e.g. chest to tricep
    // logUtil('').debug('If we go from a major to a minor muscle group, decrease
    // the weight')
    return weight / 3.5
  } else if (!MINOR_MUSCLES.includes(muscle) &&
    MINOR_MUSCLES.includes(suggestedMuscle)) {
    // logUtil('').debug('If we go from a minor to a major muscle group, increase
    // the weight') If we go from a minor to a major muscle group, increase the
    // weight e.g. tricep to chest
    return weight * 2.5
  }

  // Default
  return weight / 1.5
}

function createSuggestedFromExercisesExerciseLogSummaryAction (exercise) {
  return (dispatch, getState) => {
    const type = getTypeExerciseUtil(exercise)
    if (![
      EXERCISE_TYPE.STRENGTH,
      EXERCISE_TYPE.POWERLIFTING,
      EXERCISE_TYPE.OLYMPIC_WEIGHTLIFTING
    ].includes(type)) {
      return
    }

    const suggestedExerciseData = (
      getSuggestedFromExerciseLogSummarySelector(exercise)(getState())
    )
    const suggestedExercise = suggestedExerciseData.exercise
    const suggestedExerciseLogSummary = suggestedExerciseData.exerciseLogSummary

    if (!suggestedExercise || !suggestedExerciseLogSummary) {
      return
    }

    logUtil('').debug(`create from ${getValueReduxUtil(
      suggestedExercise,
      [EXERCISE_KEY.NAME]
    )} -> ${getValueReduxUtil(exercise, EXERCISE_KEY.NAME)}`)
    const oneRepMax = (
      getOneRepMaxExerciseLogSummaryUtil(suggestedExerciseLogSummary) ||
      getEstimatedOneRepMaxExerciseLogSummaryUtil(suggestedExerciseLogSummary)
    )

    if (!oneRepMax) {
      return
    }

    const suggestedOneRepMax = getSuggestedOneRepMax(oneRepMax,
      exercise,
      suggestedExercise
    )

    return dispatch(createExerciseLogSummaryAction({
      [EXERCISE_LOG_SUMMARY_KEY.EXERCISE_ID]: getIdReduxUtil(exercise),
      [EXERCISE_LOG_SUMMARY_KEY.ESTIMATED_ONE_REP_MAX]: suggestedOneRepMax
    }))
  }
}

function updateSetDataWithNewWeights (params) {
  return (dispatch) => {
    const {
      setData,
      exercise,
      profileWeightUnit
    } = params

    let exerciseLogSummary = params.exerciseLogSummary
    return setData.map(set => {
      const weight = set[SET_DATA_KEY.WEIGHT]
      if (!weight) {
        return set
      }

      const reps = (
        set[SET_DATA_KEY.REPS] ||
        getRepsFromDurationSetDataUtil(set[SET_DATA_KEY.TIME])
      )

      if (!reps) {
        return set
      }

      if (!exerciseLogSummary) {
        exerciseLogSummary = dispatch(
          createSuggestedFromExercisesExerciseLogSummaryAction(exercise))
      }

      if (!exerciseLogSummary) {
        return set
      }

      const newWeight = (
        getWeightFromRepsAndOneRepMaxExerciseLogSummaryUtil(exerciseLogSummary,
          reps,
          weight
        )
      )

      if (newWeight === weight) {
        return set
      }

      const weightEquipment = (
        getEquipmentWeightUtil(newWeight,
          exercise,
          (
            set[SET_DATA_KEY.WEIGHT_UNIT] || profileWeightUnit
          )
        )
      )

      if (!weightEquipment) {
        // logUtil('').debug(`[${getValueReduxUtil(exercise, EXERCISE_KEY.NAME)}]
        // [noop] equipment weight not found: `, set)
        return {
          ...set,
          [SET_DATA_KEY.WEIGHT]: newWeight
        }
      }

      // logUtil('').debug(`[${getValueReduxUtil(exercise, EXERCISE_KEY.NAME)}]
      // updating weight from ${weight} to ${newWeight} for reps ${reps}: `,
      // weightEquipment)
      return {
        ...set,
        [SET_DATA_KEY.WEIGHT]: getWeightEquipmentValueUtil(weightEquipment)
      }
    })
  }
}

function updateSetDataWeightsAction (params) {
  return (dispatch, getState) => {
    const {
      workoutExercise,
      exerciseId,
      shouldKeepWorkoutRecommended
    } = params
    const profileWeightUnit = getWeightUnitProfileSelect(getState())
    const exercise = getByIdExerciseSelector(exerciseId)(getState())
    const exerciseLogSummary = (
      getByExerciseIdExerciseLogSummarySelector(exerciseId)(getState())
    )

    const setData = (
      (
        getValueReduxUtil(workoutExercise, WORKOUT_EXERCISE_KEY.SET_DATA) || []
      )
    )

    const newSetData = dispatch(updateSetDataWithNewWeights({
      profileWeightUnit,
      exercise,
      setData,
      exerciseLogSummary
    }))

    if (isEqualUtil(setData, newSetData)) {
      return
    }

    dispatch(updateWorkoutExerciseAction({
      type: WORKOUT_EXERCISES_ACTION.UPDATE_SET_DATA_FROM_PROFILE,
      payload: {
        key: WORKOUT_EXERCISE_KEY.SET_DATA,
        value: newSetData,
        workoutExercise,
        shouldKeepWorkoutRecommended
      }
    }))
  }
}

function updateSetDataFromProfileWorkoutExerciseAction (params) {
  return (dispatch, getState) => {
    let {
      workoutExercise,
      exerciseId,
      shouldKeepWorkoutRecommended
    } = params

    workoutExercise = (
      workoutExercise || getCurrentWorkoutExerciseSelect(getState())
    )
    if (!workoutExercise) {
      return
    }

    exerciseId = (
      exerciseId ||
      getValueReduxUtil(workoutExercise, WORKOUT_EXERCISE_KEY.EXERCISE_ID)
    )
    const workoutSectionId = (
      getValueReduxUtil(workoutExercise,
        WORKOUT_EXERCISE_KEY.WORKOUT_SECTION_ID
      )
    )
    const workoutSection = (
      getByIdWorkoutSectionSelector(workoutSectionId)(getState())
    )

    if (!exerciseId ||
      (
        workoutSection && isWarmUpOrStretchingWorkoutSectionUtil(workoutSection)
      )) {
      return
    }

    return (
      dispatch(updateSetDataWeightsAction({
        workoutExercise,
        exerciseId,
        shouldKeepWorkoutRecommended
      }))
    )
  }
}

export { updateSetDataFromProfileWorkoutExerciseAction }
